import {
	USER_CF_TYPE,
	REPORTER_TYPE,
	ASSIGNEE_TYPE,
	MULTI_USER_CF_TYPE,
	PEOPLE_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { SUPPORTED_MULTI_USER_TYPES, SUPPORTED_USER_TYPES } from '../types.tsx';

export const userSupportedTypes: SUPPORTED_USER_TYPES[] = [
	USER_CF_TYPE,
	REPORTER_TYPE,
	ASSIGNEE_TYPE,
];

export const multiUserSupportedTypes: SUPPORTED_MULTI_USER_TYPES[] = [
	MULTI_USER_CF_TYPE,
	PEOPLE_CF_TYPE,
];
